import { COUPON_TYPE } from 'src/app/product-capture/model/enums/coupon-type.enum';
import { ProductTypeEnum } from 'src/app/product-capture/model/enums/product-capture.enums';
import {
  PAYOFF_CALLABILITY_CALLABILITY,
  PAYOFF_CALLABILITY_CALL_EVENT_TYPE,
  PAYOFF_COUPON_CONVERSION,
  PAYOFF_COUPON_FREQUENCY,
  PAYOFF_COUPON_TYPE,
  PAYOFF_PARTICIPATION_BASE_TYPE,
  PAYOFF_PARTICIPATION_DOWNSIDE_TYPE,
  PAYOFF_PARTICIPATION_FLOOR_STRIKE,
  PAYOFF_PARTICIPATION_DOWNSIDE_LEVERAGE,
  PAYOFF_PARTICIPATION_STRIKE,
  PAYOFF_PARTICIPATION_UPSIDE_TYPE,
  SUMMARY_PERFORMANCE_TYPE,
  SUMMARY_REFERENCE_ENTITIES,
  SUMMARY_SETTLEMENT_TYPE,
  SUMMARY_UNDERLYING_ASSETS_GROUP,
  SUMMARY_FREQUENCY,
} from '../../mockups/consts/product-capture-field-selectors.consts';
import { DEFAULT_AND_HIDE_CAPITAL_BASE_VALUES } from './cln.settings';

export const REVERSE_CONVERTIBLE_SETTINGS = {
  id: ProductTypeEnum.REVERSE_CONVERTIBLE,
  label: 'Reverse Convertible',
  effects: [
    {
      formControlNames: [
        SUMMARY_REFERENCE_ENTITIES,
        PAYOFF_COUPON_CONVERSION,
        PAYOFF_CALLABILITY_CALLABILITY,
      ],
      hidden: true,
    },
    {
      formControlNames: [
        PAYOFF_PARTICIPATION_UPSIDE_TYPE,
        PAYOFF_PARTICIPATION_BASE_TYPE,
        PAYOFF_CALLABILITY_CALL_EVENT_TYPE,
      ],
      selectValues: ['NONE'],
      hidden: true,
      readOnly: false,
    },
    ...DEFAULT_AND_HIDE_CAPITAL_BASE_VALUES,
    {
      formControlNames: [PAYOFF_COUPON_TYPE],
      selectValues: [COUPON_TYPE.FIXED],
      readOnly: true,
      hidden: false,
    },
    {
      formControlNames: [PAYOFF_PARTICIPATION_DOWNSIDE_TYPE],
      selectValues: ['PUT'],
      options: ['PUT', 'KNOCK_IN_PUT'],
      hidden: false,
    },
    // TODO: Waiting for more details from Stuart/James/Ben
    // {
    // formControlNames: [PAYOFF_COUPON_FREQUENCY],
    // selectValues: ['AT_MATURITY'],
    // },
    {
      formControlNames: [
        SUMMARY_UNDERLYING_ASSETS_GROUP,
        PAYOFF_PARTICIPATION_FLOOR_STRIKE,
      ],
      hidden: false,
    },
    {
      formControlNames: [
        SUMMARY_FREQUENCY,
        SUMMARY_PERFORMANCE_TYPE,
        SUMMARY_SETTLEMENT_TYPE,
        PAYOFF_COUPON_FREQUENCY,
      ],
      readOnly: false,
    },
    {
      formControlNames: [PAYOFF_PARTICIPATION_DOWNSIDE_LEVERAGE],
      selectValues: [
        {
          minValue: null,
          maxValue: null,
          value: null,
          indicativeValue: null,
        },
      ],
      readOnly: false,
    },
    {
      formControlNames: [PAYOFF_PARTICIPATION_STRIKE],
      selectValues: [
        {
          minValue: null,
          maxValue: null,
          value: null,
          indicativeValue: null,
        },
      ],
    },
  ],
};
